import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LoginForm from '../login/LoginForm';
import ForgotPassword from '../login/ForgotPassword';
import LoginLayout from './LoginLayout';
import SetPassword from '../login/SetPassword';

const AuthLayout = () => {
  const {isAuthenticated} = useSelector((state) => state.auth);

  return (
    <Routes>
      <Route path='/login' element={isAuthenticated ? <Navigate  to='/dashboard' /> : <LoginLayout><LoginForm /></LoginLayout>} />
      <Route path='/forgot-password' element={isAuthenticated ? <Navigate  to='/dashboard'/> : <LoginLayout><ForgotPassword /></LoginLayout>} />
      <Route path='/set-password' element={isAuthenticated ? <Navigate  to='/dashboard'/> : <LoginLayout><SetPassword/></LoginLayout>} />
    </Routes>
  );
};

export default AuthLayout;
